import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import * as _ from 'lodash-es';

import { AdminService } from '../../../services/core.admin.service';
import { UiService } from '../../../services/core.ui.service';

@Component({
    selector: 'adminChangePasswordModal',
    template: require('./admin.change-password.component.html')
})
export class AdminChangePasswordComponent implements OnInit {

    @Input() user: any = null;
    @Input() close: any = null;

    protected password: string = '';
    protected confirm: string = '';
    protected err: string = '';

    constructor(
        private adminService: AdminService, 
        private uiService: UiService
    ) { }
    
    ngOnInit() {
        this.password = "";
        this.confirm = "";
        this.err = "";
    }

    submit = () => {
        this.adminService.postPassword(
            this.user.unixName, 
            { password: this.password, unixName: this.user.unixName }
        ).then(() => {
                this.uiService.message.showSuccess('Password updated.', 'Success');
                this.closeModal();
            }, (response) => {
                var body = response.error || response.data;
                var errors = Array.isArray(body)
                    ? body
                    : _.get(body, 'password', []);
                var regexErrorDesc = _.find(errors, { type: 'regexdescription' });
                var regexError = _.find(errors, { type: 'regex' });
                if (regexErrorDesc) {
                    this.err = regexErrorDesc.args[0];
                    if (regexError) {
                        this.err += ' - Must match: ' + regexError.args[0];
                    }
                } else {
                    this.err = 'Invalid password.';
                }
            }
        );
    };

    valid = () => {
        if (!this.password || !this.confirm) {
            if (!this.err || this.err === 'Passwords must match') {
                this.err = '';
            }
            return false;
        }

        if (this.password === this.confirm) {
            if (this.err === 'Passwords must match') {
                this.err = '';
            }
            return true;
        } else {
            this.err = 'Passwords must match';
            return false;
        }
    };

    closeModal = () => {
        if (typeof(this.close) == 'function') {
            this.close();
        }
    };
}